var _line, _g, _g2, _g3, _g4, _line2, _line3, _g5, _line4, _text, _text2, _text3, _g6, _g7, _line5, _g8, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHasRodNew2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "625px",
    height: "640px",
    viewBox: "0 0 625 640",
    enableBackground: "new 0 0 625 640",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 0,
    y1: 614.6,
    x2: 541,
    y2: 614.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M562.9,619.9v-13.3h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9v6.1H562.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M573.7,619.9v-13.3h1.7v11.9h6.2v1.5H573.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M584.1,616.8c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5s2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 c-1.3,0-2.4-0.3-3.5-0.9S584.6,617.8,584.1,616.8z M585,613.3c0,1,0.2,2,0.6,2.8c0.4,0.8,1,1.5,1.7,1.9s1.6,0.7,2.6,0.7 s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9s0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 S585,611.7,585,613.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M599.4,616.8c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5s2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 c-1.3,0-2.4-0.3-3.5-0.9S599.9,617.8,599.4,616.8z M600.3,613.3c0,1,0.2,2,0.6,2.8c0.4,0.8,1,1.5,1.7,1.9s1.6,0.7,2.6,0.7 s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9s0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 S600.3,611.7,600.3,613.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M614.4,619.9v-13.3h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6 c-0.2,0.5-0.5,0.9-0.8,1.2c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3H616v5.3H614.4z M616,613.2h3.5 c0.8,0,1.4-0.2,1.9-0.7c0.5-0.5,0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7H616V613.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128.3,
    y: 136.4,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.4,
    y: 159.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M553.8,28.9c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-1.9,0.5-2.8s0.8-1.6,1.5-2.2s1.3-1.1,2.2-1.4 c0.8-0.3,1.7-0.5,2.7-0.5c2.1,0,3.8,0.9,5.1,2.6l-1.4,0.8c-0.4-0.6-0.9-1.1-1.6-1.4c-0.7-0.4-1.4-0.5-2.1-0.5 c-1.5,0-2.7,0.5-3.7,1.5s-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8s1.1,1.5,1.8,1.9s1.7,0.7,2.6,0.7c0.7,0,1.4-0.2,2.1-0.5 c0.7-0.4,1.2-0.8,1.6-1.4l1.4,0.8c-1.3,1.8-3,2.7-5.1,2.7c-1,0-1.8-0.2-2.7-0.5c-0.8-0.3-1.6-0.8-2.2-1.4S554.2,29.8,553.8,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M567.4,32.8V19.4h8.7v1.5H569v4.3h6.9v1.5H569v4.6h7.1v1.5H567.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M578.8,32.8V19.4h1.7v13.3H578.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M583.3,32.8V19.4h1.7v11.9h6.2v1.5H583.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M593.4,32.8V19.4h1.7v13.3H593.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M598.2,32.8V19.4h1.7l7.7,10.4V19.4h1.7v13.3h-1.6l-7.8-10.6v10.6H598.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M612.3,28.9c-0.4-0.9-0.5-1.8-0.5-2.8s0.2-2,0.5-2.8c0.4-0.9,0.8-1.6,1.5-2.2c0.6-0.6,1.3-1.1,2.2-1.4 c0.8-0.3,1.7-0.5,2.7-0.5c2.1,0,3.9,0.8,5.2,2.5l-1.3,0.8c-0.4-0.6-1-1-1.7-1.3s-1.4-0.5-2.2-0.5c-1.5,0-2.7,0.5-3.7,1.5 s-1.5,2.3-1.5,3.9c0,1,0.2,2,0.7,2.8c0.4,0.8,1.1,1.5,1.8,1.9c0.8,0.5,1.7,0.7,2.6,0.7c0.7,0,1.4-0.1,2.1-0.4 c0.6-0.3,1.2-0.6,1.5-1v-2.7h-4.6v-1.5h6.2v4.8c-0.6,0.7-1.4,1.3-2.3,1.7c-0.9,0.4-1.9,0.6-2.9,0.6c-0.9,0-1.8-0.2-2.7-0.5 c-0.8-0.3-1.6-0.8-2.2-1.4C613.1,30.5,612.7,29.8,612.3,28.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.8775,
    x1: 468.9,
    y1: 63.2,
    x2: 67.9,
    y2: 63.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "466.3,54.6 481.3,63.2 466.3,71.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "70.4,54.8 55.5,63.4 70.4,72  "
  }))))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.5216,
    x1: 481.1,
    y1: 47.3,
    x2: 481.1,
    y2: 79.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.5417,
    x1: 55.7,
    y1: 47.3,
    x2: 55.7,
    y2: 79.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9066,
    x1: 102.4,
    y1: 114.7,
    x2: 102.4,
    y2: 511.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "93.7,117.3 102.4,102.2 111.1,117.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "93.7,509 102.4,524.1 111.1,509  "
  }))))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 84.9,
    y1: 525.4,
    x2: 126.6,
    y2: 525.4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 51.8652 336.6296)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 18
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 86.0558 336.6296)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 18
  }, "B")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 262.3009 56.792)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 18
  }, "C")), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M528.4,99.8V86.5h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6c-0.2,0.5-0.5,0.9-0.8,1.2 c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3h-2.7v5.3H528.4z M530.1,93h3.5c0.8,0,1.4-0.2,1.9-0.7 c0.5-0.5,0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7h-3.5V93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M540.8,96.7c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5c1-0.6,2.2-0.9,3.5-0.9 s2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 s-2.4-0.3-3.5-0.9C542.2,98.5,541.4,97.7,540.8,96.7z M541.7,93.1c0,1,0.2,2,0.6,2.8s1,1.5,1.7,1.9c0.7,0.5,1.6,0.7,2.6,0.7 s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9c0.4-0.8,0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 C542.2,90.3,541.7,91.6,541.7,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M555.9,99.8V86.5h4.6c1.4,0,2.6,0.3,3.6,0.9c1,0.6,1.8,1.4,2.4,2.4c0.6,1,0.8,2.1,0.8,3.4 c0,0.9-0.2,1.8-0.5,2.6c-0.3,0.8-0.8,1.5-1.4,2.1s-1.3,1.1-2.2,1.4c-0.9,0.3-1.8,0.5-2.8,0.5H555.9z M557.5,98.3h2.9 c1,0,2-0.2,2.8-0.7c0.8-0.5,1.4-1.1,1.8-1.9c0.4-0.8,0.6-1.6,0.6-2.6c0-1-0.2-1.9-0.6-2.6c-0.4-0.8-1-1.4-1.8-1.9 c-0.8-0.5-1.7-0.7-2.8-0.7h-2.9V98.3z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.913,
    x1: 70,
    y1: 114.8,
    x2: 70,
    y2: 602.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "61.3,117.3 70,102.2 78.7,117.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "61.3,600.2 70,615.3 78.7,600.2  "
  }))))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474646",
    strokeWidth: 3.043,
    x1: 0,
    y1: 26.4,
    x2: 542.5,
    y2: 26.4
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.3,
    y: 85.4,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.8061,
    width: 425.7,
    height: 12
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 481.1,
    y: 82.4,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.8051,
    width: 30,
    height: 18.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 82.4,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.8061,
    width: 30,
    height: 18.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasRodNew2);
export default __webpack_public_path__ + "static/media/has_rod_new2.d79b2ebe1c59a81c080278aa5e5594ac.svg";
export { ForwardRef as ReactComponent };